const NAMESPACE = "APP_ENTRY";
const actionType = type => `${NAMESPACE}_${type}`;

export const businessInfoConstants = {
	SET_VALUE: "SET_VALUE",
	SET_DAYS_TO_DELIVERY: "SET_DAYS_TO_DELIVERY",

	SEND_GEO_LOCATION_SUCCESS: "SEND_GEO_LOCATION_SUCCESS",
	SEND_GEO_LOCATION_ERROR: "SEND_GEO_LOCATION_ERROR",

	SET_BANKS: actionType("SET_BANKS"),
	SET_BILLING_BANKS: actionType("SET_BILLING_BANKS"),

	WEB_SITE_CHECK_REQUEST: "WEB_SITE_CHECK_REQUEST",
	WEB_SITE_CHECK_SUCCESS: "WEB_SITE_CHECK_SUCCESS",
	WEB_SITE_CHECK_ERROR: "WEB_SITE_CHECK_ERROR",

	UPDATE_WEB_SITE_INFORMATION_REQUEST: "UPDATE_WEB_SITE_INFORMATION_REQUEST",
	UPDATE_WEB_SITE_INFORMATION_SUCCESS: "UPDATE_WEB_SITE_INFORMATION_SUCCESS",
	UPDATE_WEB_SITE_INFORMATION_ERROR: "UPDATE_WEB_SITE_INFORMATION_ERROR",
};
